import React, { memo } from 'react';

const CaseStatusCard = ({ caseInfo }) => {
    if (!caseInfo) return null;

    const formatCurrency = (amount) => {
        // Exact logic from App.js to ensure consistency
        const val = Number(String(amount).replace(/[^0-9.-]/g, "") || 0);
        return "$" + val.toLocaleString();
    };

    const getStatusStyle = (status) => {
        switch (status) {
            case "Approved":
                return {
                    bg: "rgba(16, 185, 129, 0.2)",
                    text: "#34d399",
                    border: "rgba(52, 211, 153, 0.3)"
                };
            case "Processing":
                return {
                    bg: "rgba(14, 165, 233, 0.2)",
                    text: "#38bdf8",
                    border: "rgba(56, 189, 248, 0.3)"
                };
            case "Action Required":
                return {
                    bg: "rgba(244, 63, 94, 0.2)",
                    text: "#fb7185",
                    border: "rgba(251, 113, 133, 0.3)"
                };
            default:
                return {
                    bg: "rgba(148, 163, 184, 0.2)",
                    text: "#94a3b8",
                    border: "rgba(148, 163, 184, 0.3)"
                };
        }
    };

    const style = getStatusStyle(caseInfo.status);

    return (
        <div
            style={{
                marginBottom: "28px",
                padding: "16px",
                borderRadius: "14px",
                background: "rgba(59,130,246,0.08)",
                border: "1px solid rgba(59,130,246,0.25)",
                color: "#e2e8f0",
                textAlign: "left",
            }}
        >
            <p style={{ margin: "0 0 6px", fontSize: "13px", color: "#93c5fd" }}>Welcome back</p>
            <p style={{ margin: "0 0 10px", fontWeight: 700, fontSize: "18px", color: "#e2e8f0" }}>
                {caseInfo.name || "Borrower"}
            </p>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px", fontSize: "13px" }}>
                <span style={{ color: "#cbd5e1" }}>Case #: <strong>{caseInfo.caseNumber}</strong></span>
                <span style={{ color: "#cbd5e1", display: "flex", alignItems: "center", gap: "6px" }}>
                    Status:
                    <span style={{
                        padding: "2px 8px",
                        borderRadius: "12px",
                        fontSize: "11px",
                        fontWeight: 700,
                        backgroundColor: style.bg,
                        color: style.text,
                        border: `1px solid ${style.border}`
                    }}>
                        {caseInfo.status.toUpperCase()}
                    </span>
                </span>
                <span style={{ color: "#cbd5e1" }}>Loan Type: <strong>{caseInfo.loanType}</strong></span>
                <span style={{ color: "#cbd5e1" }}>
                    Amount:{" "}
                    <strong>
                        {formatCurrency(caseInfo.loanAmount)}
                    </strong>
                </span>
                <span style={{ color: "#cbd5e1" }}>Address: <strong>{caseInfo.propertyAddress}</strong></span>
            </div>
        </div>
    );
};

export default memo(CaseStatusCard);
